export default __webpack_public_path__ + "static/media/postbits_usage.fd9feff7.jpg";